<template>
  <v-dialog
    v-model="show"
    width="100%"
    overlay-opacity="100"
    overlay-color="#000"
    persistent
  >
    <v-container fluid>
      <v-card color="black">
        <div class="text-end">
          <v-btn icon @click="cerrar">
            <v-icon size="35px" color="white">mdi-close</v-icon>
          </v-btn>
        </div>
        <embed
          :src="archivoBlob"
          type="application/pdf"
          width="100%"
          style="height: 80vh"
        />
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: "AppDocumentVisor",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    archivo: {
      default: null,
    },
  },
  data() {
    return {
      archivoBlob: null,
    };
  },
  methods: {
    cerrar() {
      if (this.archivoBlob && this.archivoBlob.startsWith("blob:")) {
        URL.revokeObjectURL(this.archivoBlob);
      }
      this.$emit("cerrar");
    },
    convertirBase64ABlob(base64) {
      const byteString = atob(base64.split(",")[1] ?? base64);
      const mimeString = base64.includes(",")
        ? base64.split(",")[0].split(":")[1].split(";")[0]
        : "application/pdf";
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    },
  },
  watch: {
    archivo: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.archivoBlob = null;
          return;
        }
        // Blob URL
        if (typeof val === "string" && val.startsWith("blob:")) {
          this.archivoBlob = val;
          return;
        }
        // URL http
        if (typeof val === "string" && val.startsWith("http")) {
          this.archivoBlob = val;
          return;
        }
        // Data URI
        if (typeof val === "string" && val.startsWith("data:")) {
          this.archivoBlob = val;
          return;
        }
        // Base64 puro
        try {
          const blob = this.convertirBase64ABlob(
            `data:application/pdf;base64,${val}`
          );
          this.archivoBlob = URL.createObjectURL(blob);
        } catch {
          this.archivoBlob = null;
        }
      },
    },
  },
};
</script>
